import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { Metamodel } from 'app/model/base/model';
import _ from 'lodash';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { WebTableDataset } from 'app/model/dataset/web-table.dataset';
import { DatasetAdapter } from 'app/model/adapters/datasets/dataset.adapter';
import { tabularPropertiesCommonAdapts } from './tabular-type.dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(WebTableDataset),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            ...tabularPropertiesCommonAdapts,
            typeProperties: {
                index: '*',
                path: '*'
            }
        }
    }
})
export class WebTableDatasetAdapter extends DatasetAdapter<WebTableDataset, Model.DatasetResource> {
    protected async _toResource(dataset: WebTableDataset): Promise<Model.DatasetResource> {
        const modelDatasetResource = await super._toResource(dataset) as Model.DatasetResource;
        const modelDataset = this.properties(modelDatasetResource) as Model.WebTableDataset;
        modelDataset.type = Metamodel.modelFor(WebTableDataset).name;
        if (dataset.isV2) {
            modelDataset.schema = this.columnValueToResource(dataset, dataset.columns);
        } else {
            modelDataset.structure = this.columnValueToResource(dataset, dataset.columns);
        }
        modelDataset.typeProperties = {
            index: ValueAdapter.toResource(dataset, WebTableDataset.TABLE_INDEX),
            path: ValueAdapter.toResource(dataset, WebTableDataset.TABLE_PATH)
        };
        if (dataset.raw) {
            const parsed = JSON.parse(dataset.raw);
            _.merge(modelDatasetResource, parsed);
        }
        return modelDatasetResource;
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: WebTableDataset): Promise<WebTableDataset> {
        if (!dataset) {
            dataset = WebTableDataset.MODEL.create<WebTableDataset>(modelDatasetResource.name);
        }
        await super._toModel(modelDatasetResource, dataset);
        const model = modelDatasetResource.properties as Model.WebTableDataset;

        if (model) {
            if (model.typeProperties) {
                ValueAdapter.toModel(dataset, WebTableDataset.TABLE_INDEX, model.typeProperties.index);
                if (model.typeProperties.index != null && model.typeProperties.index['type'] !== 'Expression' && !/^[0-9]+$/.test(model.typeProperties.index)) {
                    dataset.tableIndex = undefined;
                }
                ValueAdapter.toModel(dataset, WebTableDataset.TABLE_PATH, model.typeProperties.path);
            }
            dataset.isV2 = model.schema != null;
            dataset.columns = this.columnResourceToValue(dataset, dataset.isV2 ? model.schema : model.structure);
        }

        dataset.raw = JSON.stringify(await ValueAdapter.remainder(this.context, modelDatasetResource, WebTableDataset.MODEL));
        return dataset;
    }
}
